module.exports = __webpack_public_path__ + "static/media/tree_3.036cc58e.svg";